export const TRANSLATION_KEY = 'comments';
